import HTTP from '../../../../api/AxiosConfig';

export const getRecipes = (request) =>
    HTTP.post('/recipes/recipes-page', request);

export const saveRecipe = (recipe) =>
    HTTP.post('/recipes', recipe);

export const getNewRecipe = () =>
    HTTP.get('/recipes/newRecipe').finally(
        (response) =>
            new Promise((resolve) => {
                resolve(response);
            }),
    );

export const addRecipeProduct = (recipe, productId) =>
    HTTP.post('/recipes/newRecipe/addProduct?productId=' + productId, recipe);

export const removeRecipeProduct = (recipe, productId) =>
    HTTP.post('/recipes/newRecipe/removeProduct?productId=' + productId, recipe);

export const getRecipeToUpdate = (id) =>
    HTTP.get('/recipes/fetchRecipe?recipeId=' + id).finally(
        (response) =>
            new Promise((resolve) => {
                resolve(response);
            }),
    );

export const deleteRecipeRequest = (id) =>
    HTTP.delete('/recipes?id=' + id);

export const fetchRecipePdf = (id) =>
    HTTP.get('/recipes/pdf?recipeId=' + id, {
        method: 'GET',
        responseType: 'blob',
    }).finally(
        (response) =>
            new Promise((resolve) => {
                resolve(response);
            }),
    );